import { Link } from "@mui/material";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import { chargeManagementPath } from "../utils/chargeManagementPath";

interface Props {
  chargeId: number | null | undefined;
  heatName?: string | null;
  children: ReactNode;
}

export const ChargeLink = ({ chargeId, heatName, children }: Props) => {
  if (chargeId === null || chargeId === undefined) return <>{children}</>;

  return (
    <Link
      component={RouterLink}
      to={chargeManagementPath(chargeId)}
      target="_blank"
      rel="noopener noreferrer"
      title={heatName ? `Open heat ${heatName}` : `Open charge ${chargeId}`}
      color="inherit"
      underline="always"
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </Link>
  );
};
